<div class="error-page-container">
  <div class="error-page-content">
    <i class="an an-question error-icon"></i>
    <h1 class="error-code">404</h1>
    <h2 class="error-title">Página não encontrada</h2>
    <p class="error-description">
      A página que você está tentando acessar não existe ou foi removida.
      Verifique o endereço digitado ou retorne ao início.
    </p>
    <div class="error-actions">
      <po-button
        p-label="Acessar documentação"
        p-icon="po-icon po-icon-info"
        (p-click)="openDocumentation()">
      </po-button>
      <po-button
        p-label="Ir para o início"
        p-icon="po-icon po-icon-home"
        (p-click)="goHome()">
      </po-button>
    </div>
  </div>
</div>
